import { Button, Flex, notification, Typography } from 'antd'
import React, { useEffect } from 'react'
import { useUserContext } from '~/core/context'
import { DesignSystem } from '~/core/designSystem'
import { usePwaContext } from '../../context'
import { IphoneNotification } from '../IphoneNotification'

export const Internal: React.FC = () => {
  const { session } = useUserContext()
  const pwa = usePwaContext()
  const [api, contextHolder] = notification.useNotification()

  const hasAlreadyOpen = localStorage.getItem(
    `${session.user.id}-pwa-promotion`,
  )

  const handleClose = () => {
    pwa.promotion.setVisible(false)
    api.destroy()
    localStorage.setItem(`${session.user.id}-pwa-promotion`, 'true')
  }

  useEffect(() => {
    if (pwa.isSupported && hasAlreadyOpen !== 'true') {
      pwa.promotion.setVisible(true)
    }
  }, [pwa.isSupported, hasAlreadyOpen])

  useEffect(() => {
    if (!pwa.promotion.isVisible) {
      return
    }

    api.open({
      message: '',
      description: (
        <Flex vertical align="center" style={{ marginRight: '36px' }}>
          <Typography.Title style={{ textAlign: 'center' }} level={3}>
            Did you know?
          </Typography.Title>

          <Flex className="p-2">
            <IphoneNotification />
          </Flex>

          <Typography.Text style={{ textAlign: 'center' }} className="mt-4">
            You can use Marblism as a mobile app! Just open{' '}
            <b>ai.marblism.com</b> on your phone and get real-time updates from
            your AI Employees, just like a chat app.
          </Typography.Text>

          <Flex vertical gap={8} className="mt-5">
            <Button block onClick={handleClose} type="primary">
              Got it
            </Button>
          </Flex>
        </Flex>
      ),
      placement: 'top',
      duration: 0, // Stay until dismissed
      icon: <></>,
      key: 'popup-mobile-app',
      onClose: handleClose,
    })
  }, [pwa.promotion.isVisible])

  return <>{contextHolder}</>
}

export const PromotionPopup: React.FC = () => {
  const ctx = usePwaContext()
  const designSystem = DesignSystem.use()

  if (ctx.isRunning || !ctx.isSupported || designSystem.isTouchDevice) {
    return <></>
  }

  return <Internal />
}
